import { PROJECT_KEYS } from "../config/config";

const CryptoJS = require("crypto-js");

export const getItemFromStorage = (key) => {
    const data = localStorage.getItem(key);
    return data || null;
}

export const setItemToStorage = (key, value) => {
    return localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
}

export const removeItemFromStorage = (key) => {
    return localStorage.removeItem(key);
}

export const encryptFun = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), PROJECT_KEYS.secretKey).toString();
};

export const decryptFun = (ciphertext) => {
    try {
        const bytes = CryptoJS.AES.decrypt(ciphertext, PROJECT_KEYS.secretKey);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
        console.error('Decryption failed:', error);
        return {username: '', password: ''};
    }};

export const evaluateExpression = (equation, data) => {
    if (!equation) return data;
    const parts = equation.split(',');
    // Initialize result
    let result = data;
    parts.forEach(part => {
        // Check for multiplication
        if (part.startsWith('*')) {
            // Remove '*' and parse as number
            const value = parseFloat(part.slice(1));
            result *= value; // Multiply with the result (or start with value if result is 0)
        } else if (part.startsWith('+')) {
            // Remove '+' and parse as number
            const value = parseFloat(part.slice(1));
            result += value; // Add to result
        } else if (part.startsWith('-')) {
            const value = parseFloat(part.slice(1));
            result -= value; // Add to result
        }
        else if (part.startsWith('/')) {
            const value = parseFloat(part.slice(1));
            result /= value; // Add to result
        } else {
            // Parse value directly if no operator
            console.warn("Invalid Equation part:", part);
        }
    });
    result = parseFloat(result.toFixed(2));
    return result;
};

export const calculateAgentWinLoss = (currentAgent, inputValue) => {
    let equation = currentAgent.equation;
    let calculatedValue = 0;
    // ensure inputValue is string
    let stringValue = String(inputValue || "");
    let commingValue = stringValue.replace(/,/g, "").replace(/[^\d.-]/g, "");

    commingValue = parseFloat(commingValue);
    if (!isNaN(commingValue)) {
        calculatedValue = currentAgent.exchangeUnitRate * commingValue;
    } else {
        calculatedValue = 0;
    }
    let calculatedResult = evaluateExpression(equation, calculatedValue)
    if (!currentAgent.showPositive) {
        calculatedResult *= -1;
    }

    return {
        winLoss: Math.round(calculatedResult),
        siteData: inputValue,
        commingValue: commingValue // returning parsed float value as well in case needed
    };
};
